// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'

//VUEX 
import Vuex from 'vuex'
Vue.use(Vuex)
import { store } from '@/store/store.js';
//.VUEX 

//AXIOS
import axios from 'axios'
import VueAxios from 'vue-axios'
axios.defaults.baseURL = store.state.server;
let token = window.localStorage.getItem('_token');
if (!!token) {
	axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
}
//.AXIOS

//VEE-VALIDATE
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
Validator.localize('es', validatorEs);
Vue.use(VeeValidate);
//.VEE-VALIDATE

Validator.extend('email', {
    validate: value => {

		let ok = false;

		ok = value.includes("@");
		if(ok){
			ok = value.includes(".")
		}

		if(ok){
			var regex = "\S*[\u00E0-\u00FC]\S*";
			let regexCompiled = new RegExp(regex);
			ok = !regexCompiled.test(value);
		}

		return ok;
    }
  });


//IDIOMAS
import VueI18n from 'vue-i18n'
import messages from './translations';

Vue.use(VueI18n);

const i18n = new VueI18n({
	locale: store.state.language,
	messages,
});
//.IDIOMAS


/*SENTRY*/
// import * as Sentry from '@sentry/browser';
// import { Vue as VueIntegration } from '@sentry/integrations';
// Sentry.init({
// 	dsn: 'https://9873ae9e28a3452bb7dbeb6e49316e52@o393426.ingest.sentry.io/5242501',
// 	integrations: [new VueIntegration({ Vue, attachProps: true, logError:true })],
// });


import Multiselect from 'vue-multiselect'

// register globally
Vue.component('multiselect', Multiselect)


import dropzone from '@/components/parts/form/dropzone';
Vue.component('dropzone', dropzone)

Vue.config.productionTip = false

function loadCookieYesScript() {
	const cookieDomain = 'empleo.fgulem.es';
	if (window.location.hostname !== cookieDomain) return;

	const scriptId = 'cookieyes';
	if (document.getElementById(scriptId)) return;

	const script = document.createElement('script');
	script.id = scriptId;
	script.type = 'text/javascript';
	script.src = 'https://cdn-cookieyes.com/client_data/541e6bf87e22061833f03b9788187c20/script.js';
	document.head.appendChild(script);
}

loadCookieYesScript();

function loadGoogleAnalytics() {
	const analyticsDomain = 'empleo.fgulem.es';
	if (window.location.hostname !== analyticsDomain) return;

	if (!window.dataLayer) window.dataLayer = [];
	if (!window.gtag) {
		window.gtag = function gtag() {
			window.dataLayer.push(arguments);
		};
	}

	window.gtag('js', new Date());
	window.gtag('config', 'G-0D8EQLBY38');

	const scriptId = 'google-analytics-gtag';
	if (document.getElementById(scriptId)) return;

	const script = document.createElement('script');
	script.id = scriptId;
	script.async = true;
	script.src = 'https://www.googletagmanager.com/gtag/js?id=G-0D8EQLBY38';
	document.head.appendChild(script);
}

loadGoogleAnalytics();

new Vue({
	el: '#app',
	router,
	i18n,
	store,
	VeeValidate,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js